
export default {

    "e-mail" : "e-mail",
    "password" : "password",
    "wrong_email_password" : "wrong email or password",
    "login" : "Login"

};